module.exports = __webpack_public_path__ + "static/media/segPaper.416eb151.png";